import { render, staticRenderFns } from "./ScoreTest.vue?vue&type=template&id=4b7bfe50&scoped=true&"
import script from "./ScoreTest.vue?vue&type=script&lang=js&"
export * from "./ScoreTest.vue?vue&type=script&lang=js&"
import style0 from "./ScoreTest.vue?vue&type=style&index=0&id=4b7bfe50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7bfe50",
  null
  
)

export default component.exports